import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import HomeScreen from "./screens/HomeScreen";
import AdminLoginScreen from "./screens/AdminLoginScreen";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import PollBreakdown from "./screens/PollBreakdown";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeScreen />,
  },
  {
    path: "/:pollID/breakdown",
    element: <PollBreakdown />,
  },
  {
    path: "/login",
    element: <AdminLoginScreen />,
  },
  { path: "/privacy", element: <PrivacyPolicy /> },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
